import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CalendarModal.css';

export default function JoinSuccessModal({ calendar, onClose }) {
  const navigate = useNavigate();
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content success-modal" onClick={(e) => e.stopPropagation()}>
        <div className="success-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
        </div>

        <h2>تم الانضمام بنجاح! 🎉</h2>
        <p className="success-description">
          لقد انضممت إلى "{calendar.name}" بنجاح. يمكنك الآن عرض التقويم وحجز المواعيد.
        </p>

        <div className="info-box">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
          </svg>
          <p>يمكنك الآن الوصول إلى هذا التقويم من لوحة التحكم الخاصة بك في أي وقت</p>
        </div>

        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onClose}>
            إغلاق
          </button>
          <button
            className="btn btn-primary"
            onClick={() => {
              onClose();
              navigate(`/calendar/${calendar.id}`);
            }}
          >
            دخول المجموعة ←
          </button>
        </div>
      </div>
    </div>
  );
}